import { useSetState as useMantineSetState } from '@mantine/hooks';

export const useSetState = useMantineSetState;
